import { render, staticRenderFns } from "./drinkQR.vue?vue&type=template&id=8cb655dc&scoped=true&"
import script from "./drinkQR.vue?vue&type=script&lang=js&"
export * from "./drinkQR.vue?vue&type=script&lang=js&"
import style0 from "./drinkQR.vue?vue&type=style&index=0&id=8cb655dc&lang=scss&scoped=true&"
import style1 from "./drinkQR.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb655dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VLayout})
